export const YOUTUBE_MDX_DIRECTIVE_NAME = 'youtube';
